export enum ItemizedBillType {
	None2,
	Complete,
	Masked
}